<div class="card-columns">
  <div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title portal-text">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.LOGIN" | translate }}</h4>
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="mb-3">
            <label for="login">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.USERNAME" | translate }}</label>
            <input
              type="text"
              class="form-control"
              id="login"
              formControlName="login"
              aria-describedby="emailHelp"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.USERNAME' | translate }}"
              required
              [class.is-valid]="login.value !== '' && login['touched'] && login.valid"
              [class.is-invalid]="login['touched'] && login.invalid" />
            @if (login.invalid && (login.dirty || login["touched"])) {
              <div class="invalid-feedback">
                @if (login.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.USERNAME_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="password">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.PASSWORD" | translate }}</label>
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              id="password"
              formControlName="password"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.PASSWORD' | translate }}"
              required
              [class.is-valid]="password.value !== '' && password['touched'] && password.valid"
              [class.is-invalid]="password['touched'] && password.invalid" />
            @if (password.invalid && (password.dirty || password["touched"])) {
              <div class="invalid-feedback">
                @if (password.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.PASSWORD_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3 form-check">
            <div class="row">
              <div class="col-8">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="showPasswordCheck"
                  (change)="showPasswordChanged()" />
                <label class="form-check-label" for="showPasswordCheck">{{
                  "GAST-PORTAL-NG.LOGIN-COMPONENT.SHOW_PASSWORD" | translate
                }}</label>
              </div>
              <div class="col-4 text-right">
                @if (isForgotPasswordHref()) {
                  <div>
                    <a id="forgot-password-url-1" target="_blank" [href]="forgotPasswordUrl()"
                      ><span>{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.FORGOT_PASSWORD" | translate }}</span></a
                    >
                  </div>
                } @else {
                  <div>
                    <a id="forgot-password-url-2" [routerLink]="forgotPasswordUrl()" preserveQueryParams
                      ><span>{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.FORGOT_PASSWORD" | translate }}</span></a
                    >
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-primary" [disabled]="!loginForm.valid">
              {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.LOGIN" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>

    @if (!hideBlockquote()) {
      <div class="card blockquote-card">
        <div class="card-body">
          <ng-content></ng-content>
        </div>
      </div>
    }
  </div>

  @if (!hideRegister()) {
    <div class="card">
      <div class="card-body">
        <h4 class="card-title portal-text">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.REGISTER" | translate }}</h4>
        <form [formGroup]="registrationForm" (ngSubmit)="onRegister()">
          <span>{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.SALUTATION" | translate }}</span>
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                value="MRS"
                formControlName="salutation"
                name="salutation"
                id="salutation1"
                [class.is-valid]="salutation.value !== '' && salutation['touched'] && salutation.valid"
                [class.is-invalid]="salutation['touched'] && salutation.invalid" />
              <label class="form-check-label" for="salutation1">{{
                "GAST-PORTAL-NG.LOGIN-COMPONENT.MRS" | translate
              }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                value="MR"
                formControlName="salutation"
                name="salutation"
                id="salutation2"
                [class.is-valid]="salutation.value !== '' && salutation['touched'] && salutation.valid"
                [class.is-invalid]="salutation['touched'] && salutation.invalid" />
              <label class="form-check-label" for="salutation2">{{
                "GAST-PORTAL-NG.LOGIN-COMPONENT.MR" | translate
              }}</label>
            </div>
          </div>
          <div class="mb-3">
            <label for="firstName">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.FIRST_NAME" | translate }}</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.FIRST_NAME' | translate }}"
              required
              [class.is-valid]="firstName.value !== '' && firstName['touched'] && firstName.valid"
              [class.is-invalid]="firstName['touched'] && firstName.invalid" />
            @if (firstName.invalid && (firstName.dirty || firstName["touched"])) {
              <div class="invalid-feedback">
                @if (firstName.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.FIRST_NAME_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="lastName">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.LAST_NAME" | translate }}</label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.LAST_NAME' | translate }}"
              required
              [class.is-valid]="lastName.value !== '' && lastName['touched'] && lastName.valid"
              [class.is-invalid]="lastName['touched'] && lastName.invalid" />
            @if (lastName.invalid && (lastName.dirty || lastName["touched"])) {
              <div class="invalid-feedback">
                @if (lastName.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.LAST_NAME_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="birthday">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.BIRTHDAY" | translate }}</label>
            <input
              id="birthday"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.BIRTHDAY' | translate }}"
              class="form-control"
              formControlName="birthday"
              bsDatepicker
              required
              [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY' }"
              (bsValueChange)="handleBirthdayChange($event)"
              [class.is-valid]="birthday.value !== '' && birthday['touched'] && birthday.valid"
              [class.is-invalid]="birthday['touched'] && birthday.invalid" />

            @if (birthday.invalid && (birthday.dirty || birthday["touched"])) {
              <div class="invalid-feedback">
                @if (birthday.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.BIRTHDAY_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="countryOfOrigin">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.COUNTRY_OF_ORIGIN" | translate }}</label>
            <select
              class="form-control"
              id="countryOfOrigin"
              formControlName="countryOfOrigin"
              required
              [class.is-valid]="countryOfOrigin.value !== '' && countryOfOrigin['touched'] && countryOfOrigin.valid"
              [class.is-invalid]="countryOfOrigin['touched'] && countryOfOrigin.invalid">
              <option [value]="null" selected disabled hidden>
                {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.SELECT_NULL_OPTION" | translate }}
              </option>
              @for (country of countries(); track country) {
                <option [value]="country.countryId">
                  {{ "GAST-COMMON-NG.COUNTRY." + country.isoCode | translate }}
                </option>
              }
            </select>
            @if (countryOfOrigin.invalid && (countryOfOrigin.dirty || countryOfOrigin["touched"])) {
              <div class="invalid-feedback">
                @if (countryOfOrigin.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.COUNTRY_OF_ORIGIN_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="email">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.EMAIL" | translate }}</label>
            <input
              type="email"
              name="email"
              class="form-control"
              id="email"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.EMAIL' | translate }}"
              formControlName="email"
              required
              email
              [class.is-valid]="email.value !== '' && email['touched'] && email.valid"
              [class.is-invalid]="email['touched'] && email.invalid" />
            <div class="invalid-feedback">
              {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.BAD_EMAIL" | translate }}
            </div>
          </div>
          <div class="mb-3">
            <label for="loginRegistration">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.USERNAME" | translate }}</label>
            <input
              type="text"
              class="form-control"
              id="loginRegistration"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.USERNAME' | translate }}"
              formControlName="loginRegistration"
              required
              [class.is-valid]="
                loginRegistration.value !== '' && loginRegistration['touched'] && loginRegistration.valid
              "
              [class.is-invalid]="loginRegistration['touched'] && loginRegistration.invalid" />
            @if (loginRegistration.invalid && (loginRegistration.dirty || loginRegistration["touched"])) {
              <div class="invalid-feedback">
                @if (loginRegistration.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.USERNAME_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <label for="passwordRegistration">{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.PASSWORD" | translate }}</label>
            <input
              type="password"
              class="form-control"
              id="passwordRegistration"
              placeholder="{{ 'GAST-PORTAL-NG.LOGIN-COMPONENT.PASSWORD' | translate }}"
              formControlName="passwordRegistration"
              required
              [class.is-valid]="
                passwordRegistration.value !== '' && passwordRegistration['touched'] && passwordRegistration.valid
              "
              [class.is-invalid]="passwordRegistration['touched'] && passwordRegistration.invalid" />
            @if (passwordRegistration.invalid && (passwordRegistration.dirty || passwordRegistration["touched"])) {
              <div class="invalid-feedback">
                @if (passwordRegistration.errors?.["required"]) {
                  <div>
                    {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.PASSWORD_IS_REQUIRED" | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="dataSecurity"
                formControlName="dataSecurity"
                required
                [class.is-valid]="dataSecurity.value !== '' && dataSecurity['touched'] && dataSecurity.valid"
                [class.is-invalid]="dataSecurity['touched'] && dataSecurity.invalid" />
              <label class="form-check-label" for="dataSecurity">
                {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.DATASECURITY_APPROVAL" | translate }}
                <a target="_blank" [href]="dataPrivacyProtectionUrl"
                  ><span>{{ "GAST-PORTAL-NG.LOGIN-COMPONENT.DATASECURITY_LINK" | translate }}</span></a
                >
              </label>
              @if (dataSecurity.invalid && (dataSecurity.dirty || dataSecurity["touched"])) {
                <div class="invalid-feedback">
                  @if (dataSecurity.errors?.["required"]) {
                    <div>
                      {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.APPROVAL_IS_REQUIRED" | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-primary" [disabled]="!registrationForm.valid">
              {{ "GAST-PORTAL-NG.LOGIN-COMPONENT.CREATE_ACCOUNT" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }
</div>
